import React, { FC } from 'react';
import HyperLink, { ENTITY_TYPE } from '../common/HyperLink';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Tag } from 'antd';

export const SL_TAG = (
	<Tag color="rgb(225, 229, 249)" style={{ color: 'rgb(11, 28, 111)' }}>
		SL
	</Tag>
);

export const getSLHyperLink = (sl, backLinkText) => (
	<HyperLink
		text={nullSafeGetOrElse(`name`, sl, '--')}
		entityType={ENTITY_TYPE.STOCK_LOCATION}
		entityId={nullSafeGetOrElse(`id`, sl, '--')}
		backLinkText={backLinkText}
	/>
);

const ViaStockLocationDisplay: FC<any> = ({
	viaStockLocation,
	backLinkText,
}): React.ReactElement => {
	return viaStockLocation ? (
		<div className="flex flex-row items-center">
			<div className="mr-2 text-gray-400">Forwarding Via</div>
			{SL_TAG}
			{getSLHyperLink(viaStockLocation, backLinkText)}
		</div>
	) : null;
};

export default ViaStockLocationDisplay;
